import React, { useState, useEffect, useRef } from 'react';
import '../assets/SearchBar.css';

const SearchBar = ({
  placeholder,
  onSearch,
  value,
  suggestions = [], // Filtered device IDs
  loading = false // To show loading state
}) => {
  const [internalValue, setInternalValue] = useState(value || '');
  const [isFocused, setIsFocused] = useState(false);
  const wrapperRef = useRef(null);

  // Update internal state if the external value changes
  useEffect(() => {
    setInternalValue(value || '');
  }, [value]);

  // Handle clicks outside the component to close dropdowns
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsFocused(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleInputChange = (e) => {
    setInternalValue(e.target.value);
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    onSearch(internalValue);
    setIsFocused(false);
  };

  const handleSuggestionClick = (suggestion) => {
    setInternalValue(suggestion);
    onSearch(suggestion);
    setIsFocused(false);
  };

  // Determine which dropdown to show
  const showSuggestions = isFocused && suggestions.length > 0;

  return (
    <div className="search-bar-wrapper" ref={wrapperRef}>
      <form onSubmit={handleFormSubmit} className={`search-container ${loading ? 'loading' : ''}`}>
        <input
          type="text"
          placeholder={placeholder}
          value={internalValue}
          onChange={handleInputChange}
          onFocus={() => setIsFocused(true)}
          className="search-input"
        />
        <button type="submit" className="search-button" disabled={loading}>
          {loading ? '...' : 'Search'}
        </button>
      </form>

      {/* Suggestions Dropdown */}
      {showSuggestions && (
        <div className="search-dropdown">
          <div className="search-dropdown-header">Filtered Devices</div>
          {suggestions.map((id) => (
            <div
              key={id}
              className="search-dropdown-item"
              onMouseDown={() => handleSuggestionClick(id)}
            >
              {id}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SearchBar;
